import { useNavigate } from "react-router-dom";

interface IRedAndWhiteCard {
  icon: JSX.Element;
  name: string;
  to: string;
}

const RedAndWhiteCard: React.FC<IRedAndWhiteCard> = ({ icon, name, to }) => {
  const navigate = useNavigate();

  return (
    <div
      className="relative flex flex-col items-center justify-center border border-primary-light rounded-lg overflow-hidden cursor-pointer bg-white "
      onClick={() => navigate(to)}
    >
      <div className="absolute top-0 left-0 w-full h-1/3 lg:h-1/2">
        <div className="absolute top-0 left-0 w-full h-full bg-primary" />
      </div>

      <div className="relative flex flex-col items-center justify-center h-full">
        <div className="bg-white hover:scale-105 hover:text-primary w-6 lg:w-12 h-6 lg:h-12 rounded-full p-1 lg:p-2 mt-2 shadow-sm shadow-black/30 text-[#484F57]">
          {icon}
        </div>
        <div className="my-2 text-sm lg:text-base text-gray-700 font-medium">
          {name}
        </div>
      </div>
    </div>
  );
};

export default RedAndWhiteCard;
